import theme from './theme';

interface ButtonTheme {
  backgroundColor: string;
  '&:hover, &:focus': {
    backgroundColor: string;
    boxShadow: string;
  };
}
// Object to define Button themes
export default {
  buttons: {
    red: {
      backgroundColor: theme.colors.red,
      '&:hover, &:focus': {
        backgroundColor: theme.colors.reds[1],
      },
    },
    white: {
      backgroundColor: theme.colors.white,
      '&:hover, &:focus': {
        color: theme.colors.reds[1],
      },
    },
  },
};
